// extracted by mini-css-extract-plugin
export default {"container":"IbcVolumeDisclaimer_container__oBN2d","icon":"IbcVolumeDisclaimer_icon__HoV7V","title":"IbcVolumeDisclaimer_title__Udt9U","link":"IbcVolumeDisclaimer_link__FduzO"};